import { useMemo } from 'react';
import { AppointmentLeadTime } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { RadioFilterSelector, FilterTraySection } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../tracking-ids';

interface AppointmentLeadTimeTrayFilterProps {
  value?: AppointmentLeadTime;
  onChange: (leadTime?: AppointmentLeadTime) => void;
}

export const AppointmentLeadTimeTrayFilter = ({ value, onChange }: AppointmentLeadTimeTrayFilterProps) => {
  const { t } = useTranslation('analytics');

  const leadTimeOptions = useMemo(() => {
    return {
      [AppointmentLeadTime.LEAD_TIME_0_1_DAYS]: t('Same day'),
      [AppointmentLeadTime.LEAD_TIME_1_3_DAYS]: t('1 to 3 days'),
      [AppointmentLeadTime.LEAD_TIME_4_10_DAYS]: t('4 to 10 days'),
      [AppointmentLeadTime.LEAD_TIME_10_PLUS_DAYS]: t('> 10 days'),
    };
  }, [t]);

  return (
    <FilterTraySection label={t('Appointment lead time')} onReset={() => onChange(undefined)} disableReset={!value}>
      <RadioFilterSelector<AppointmentLeadTime>
        options={leadTimeOptions}
        label={t('Appointment lead time')}
        onChange={(val) => {
          onChange(val as AppointmentLeadTime);
        }}
        value={value}
        showLabel={false}
        withBorder={false}
        trackingId={`${trackingIds.filterTrayToggle}-lead-time`}
      />
    </FilterTraySection>
  );
};
